<script lang="ts">
  import "../scss/app.scss";
  import "daisyui";
</script>

<main class="cursor-default">
  <slot />
</main>
